<template>
  <div class="o-ring-calculator__container">
    <div class="o-ring-calculator__header">
      <h1 class="h1--underline">
        {{ i18n.tv('Frontend.ORing.Title', 'ORingConfiguratorImport') }}
      </h1>
    </div>
    <div class="o-ring-calculator__content">
      <o-ring-calculator />
    </div>
  </div>
</template>

<script setup lang="ts">
import useBreadcrumb from '~/composables/useBreadcrumb'
import useI18nExtended from '~/composables/usei18nExtended'
import ORingCalculator from '~/components/oring-calculator/ORingCalculator.vue'
import createSeoMetaInfo from '~/assets/js/opengraph/helper'
import {getORingSeoOptions} from '~/composables/oring-helper'

const i18n = useI18nExtended()

// Add SEO metadata
const seoData = createSeoMetaInfo(getORingSeoOptions('', 'Frontend.ORing.Title', 'ORingConfiguratorImport'))
useSeoMeta(seoData)

const route = useRoute()
const router = useRouter()
let i18nHead = useLocaleHead({addSeoAttributes: true, route: route, router: router, i18n: i18n}).value

const head = {
  ...i18nHead,
  title: i18n.tv('pageTitle', 'ORingConfigurator')
}
useHead(head)

useBreadcrumb([
  {
    label: i18n.tv('oRingCalculator', 'breadcrumbs'),
    path: '/oring-calculator'
  }
])

</script>
<style lang="scss">
.o-ring-calculator__container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  h1 {
    margin: 0 2rem;
  }

  @include breakpoint-down($md) {
    h1 {
      margin: 0 1rem;
    }
  }

  .o-ring-calculator__content {
    display: flex;
    align-self: stretch;
    justify-content: space-around;
    margin-top: 1rem;
    background-color: $color__content--background__primary;
    padding: 0 2rem;
    overflow: hidden;

    @include breakpoint-down($md) {
      padding: 0 1rem;
    }
  }
}
</style>
